import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-0"}],["path",{"d":"M12 8v4","key":"svg-1"}],["path",{"d":"M12 16h.01","key":"svg-2"}]]

const IconAlertSquareRounded = createReactComponent('outline', 'alert-square-rounded', 'AlertSquareRounded', __iconNode);

export default IconAlertSquareRounded;